import { Spinner } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import {
  ArrowDown,
  BackArrow,
  BlueSuccessCheck,
  DateIcon,
  GreenSuccessCheck,
  PlaceholderImg,
  TimeIcon,
} from "./AllImages";
import Breadcrumbs from "../admin/Breadcrumbs/Breadcrumbs";
import { useEffect, useRef, useState } from "react";
import Badge from "react-bootstrap/Badge";
import { getRemainingParts } from "../../utils";

export const Box = styled.div`
  background-color: ${({ bg }) => (bg ? bg : "")};
`;

export const SpanStyled = styled.span`
  color: ${(props) => (props.color ? props.color : "")};
  border: ${(props) => (props.border ? `1px solid ${props.border}` : "")};
  border-radius: ${(props) => (props.radius ? props.radius : "")};
  line-height: ${(props) => (props.lh ? props.lh : "")};
  font-size: ${(props) => (props.size ? props.size : "")};
  font-weight: ${(props) => (props.weight ? props.weight : "")};
  letter-spacing: ${(props) => (props.spacing ? props.spacing : "")};
  text-transform: ${(props) => (props.transform ? props.transform : "")};
  background-color: ${({ bg }) => (bg ? bg : "")};
  font-family: ${(props) => (props.family ? props.family : "var(--regular)")};
  body.rtl & {
    font-family: ${(props) =>
      props.family ? props.family : "var(--arRegular)"};
  }
`;

export const HeadingStyled = styled.div`
  color: ${(props) => (props.color ? props.color : "var(--themeColor)")};
  line-height: ${(props) => (props.lh ? props.lh : "")};
  font-size: ${(props) => (props.size ? props.size : "20px")};
  display: ${(props) => (props.display ? props.display : "")};
  font-weight: ${(props) => (props.weight ? props.weight : "")};
  letter-spacing: ${(props) => (props.spacing ? props.spacing : "")};
  text-transform: ${(props) => (props.transform ? props.transform : "")};
  font-family: ${(props) =>
    props.family ? props.family : "var(--regularBold)"};
  body.rtl & {
    font-family: ${(props) =>
      props.family ? props.family : "var(--arBoldSans)"};
  }
`;

export const SubHeadingStyled = styled.div`
  color: ${(props) => (props.color ? props.color : "var(--themeColor)")};
  line-height: ${(props) => (props.lh ? props.lh : "")};
  font-size: ${(props) => (props.size ? props.size : "24px")};
  display: ${(props) => (props.display ? props.display : "")};
  font-weight: ${(props) => (props.weight ? props.weight : "")};
  letter-spacing: ${(props) => (props.spacing ? props.spacing : "")};
  text-transform: ${(props) => (props.transform ? props.transform : "")};
  font-family: ${(props) =>
    props.family ? props.family : "var(--regularBold)"};
  body.rtl & {
    font-family: ${(props) =>
      props.family ? props.family : "var(--arBoldSans)"};
  }
`;

export const TextStyled = styled.p`
  display: ${(props) => (props.display ? props.display : "flex")};
  width: ${(props) => (props.display ? props.display : "100%")};
  line-height: ${(props) => (props.lh ? props.lh : "24px")};
  font-size: ${(props) => (props.size ? props.size : "15px")};
  font-weight: ${(props) => (props.weight ? props.weight : "")};
  color: ${(props) => (props.color ? props.color : "var(--text)")};
  text-transform: ${(props) => (props.transform ? props.transform : "")};
  letter-spacing: ${(props) => (props.spacing ? props.spacing : "")};
  background-color: ${({ bg }) => (bg ? bg : "")};
  font-family: ${(props) => (props.family ? props.family : "var(--regular)")};
  body.rtl & {
    font-family: ${(props) =>
      props.family ? props.family : "var(--arRegular)"};
  }
`;

export const LabelStyled = styled.label`
  margin-left: ${({ ml }) => (ml ? ml : "")};
  min-width: ${({ minW }) => (minW ? minW : "")};
  line-height: ${(props) => (props.lh ? props.lh : "")};
  font-size: ${(props) => (props.size ? props.size : "15px")};
  font-weight: ${(props) => (props.weight ? props.weight : "")};
  letter-spacing: ${(props) => (props.spacing ? props.spacing : "")};
  color: ${(props) => (props.color ? props.color : "var(--text)")};
  white-space: ${(props) => (props.wrap ? props.wrap : "nowrap")};
  width: ${(props) => (props.width && props.width)};
  
  position: relative;
  font-family: ${(props) => (props.family ? props.family : "var(--regular)")};
  span.optional {
    display: block;
    width: 100%;
    font-size: 14px;
    color: var(--text2);
    line-height: 16px;
  }
  body.rtl & {
    font-family: ${(props) =>
      props.family ? props.family : "var(--arRegular)"};
  }
`;
export const FileUploaderStyled = styled.label`
  background: var(--white);
  border: 2px dashed var(--text2);
  min-height: 80px;
  max-width: 300px;
  height: 100px;
  border-radius: 6.9px;
  padding: 10px;
  cursor: pointer;
  &.w-100 {
    max-width: 100%;
  }
  &:hover {
    border-color: var(--textPlaceholder2);
  }
`;
export const IconBoxColor = styled.div`
  svg {
    [stroke] {
      stroke: ${({ iconColor }) => (iconColor ? iconColor : "")};
    }
  }
`;

export const sliceProps = (props, sub) => {
  const { children, ...otherProps } = props;
  sub.forEach((prop) => delete otherProps[prop]);
  return otherProps;
};

export const LazyImage = (props) => {
  return <LazyLoadImage className="custom-img" {...props} effect="blur" />;
};

export const ThemeLoader = () => {
  return (
    <Box className="d-flex justify-content-center align-items-center py-5">
      <Spinner className="main-spinner" />
    </Box>
  );
};

export const StatusText = ({ text, status }) => {
  return (
    <StatusContainer
      status={status}
      className="d-flex align-items-center gap-2 text-nowrap"
    >
      <div className="status-color-box" />
      <SpanStyled>{text}</SpanStyled>
    </StatusContainer>
  );
};
export const TextWithIcon = (props) => (
  <TextWithStyledWrapper
    color={props.color}
    className={`d-flex ${
      props.desc ? "align-items-start" : "align-items-center"
    }`}
  >
    <Box className="mx-2 d-flex align-items-center justify-content-center">
      <props.icon width="24px" height="24px" />
    </Box>
    <Box>
      <TextStyled
        className="mb-0"
        weight={400}
        size={props.headingSize ? props.headingSize : "14px"}
        color={!props.alsotextColor ? "var(--text2)" : "var(--text2)"}
        dangerouslySetInnerHTML={{ __html: props.title }}
      ></TextStyled>
      {props.desc ? (
        <SpanStyled
          className="text-uppercase"
          color={"var(--greyText)"}
          size="12px"
          weight={300}
        >
          {props?.desc}
        </SpanStyled>
      ) : null}
    </Box>
  </TextWithStyledWrapper>
);
const TextWithStyledWrapper = styled.div`
  svg {
    [stroke] {
      stroke: ${({ color }) => (color ? color : "")};
    }
  }
`;

export const SelectionDropdown = (props) => {
  const unwantedProps = ["options", "register", "validationRules"];
  const { register, validationRules, name } = props;
  const dropdownRef = useRef(null);

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;

    if (
      scrollHeight - scrollTop <= clientHeight + 50 &&
      props.hasMore &&
      !props.loading
    ) {
      props.onLoadMore();
    }
  };
  return (
    <DropdownStyled
      {...sliceProps(props, unwantedProps)}
      ref={dropdownRef}
      onScroll={handleScroll}
      arrow={ArrowDown}
      {...(register && register(name, validationRules))}
    >
      <option value="" className="label">
        {props.placeholder && props.placeholder}
      </option>
      {props.options &&
        props.options.length > 0 &&
        props.options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      {props.loading && <option disabled>Loading more cities...</option>}
    </DropdownStyled>
  );
};
export const DateInfo = ({ date }) => {
  return (
    <Box className="d-flex gap-2 small text-muted">
      <DateIcon />
      <SpanStyled size="14px" color="var(--text)">
        {date}
      </SpanStyled>
    </Box>
  );
};

export const TimeInfo = ({ time }) => {
  return (
    <Box className="d-flex gap-2 small text-muted">
      <TimeIcon />
      <SpanStyled size="14px" color="var(--text)">
        {time}
      </SpanStyled>
    </Box>
  );
};

export const UserInfo = ({
  name,
  userRole,
  avatar,
  subLabel,
  textAlign,
  userId,
}) => {
  const {t} = useTranslation()
  return (
    <Box className="d-flex gap-2 align-items-center justify-content-center">
      <Box className="profile-avatar">
        <LazyImage
          src={avatar || PlaceholderImg}
          alt={name}
          className="rounded-circle mr-2 w-100 h-100"
        />
      </Box>
      <Box className="d-flex flex-column">
        <SpanStyled
          style={{ textAlign: textAlign && textAlign }}
          size="14px"
          weight={userId ? "bold" : ""}
          className="text-nowrap"
        >
          {t(name)}
        </SpanStyled>
        {userRole ? (
          <SpanStyled size="14px" color="var(--text2)" className="text-align-start">
            {userRole}
          </SpanStyled>
        ) : (
          <SpanStyled size="14px" color="var(--text2)" className="text-align-start">
            {subLabel}
          </SpanStyled>
        )}
      </Box>
    </Box>
  );
};

export const BackButton = (props) => {
  return (
    <BackButtonWrapper {...props} className="d-flex align-items-center gap-2">
      <button type="button" className="icon-box border-0">
        <BackArrow color="var(--text)" />
      </button>
      <SpanStyled
        className={`${props.clName ? props.clName : ""}`}
        weight={700}
        color="var(--text)"
        size="16px"
      >
        {props.label && props.label}
      </SpanStyled>
    </BackButtonWrapper>
  );
};

export const TabsList = ({
  tabs,
  activeTab,
  handleTabChange,
  receivedRequestsCount,
  sentRequestsCount,
}) => {
  const { t } = useTranslation();
  return (
    <TabStyled className="mb-0 list-unstyled d-flex justify-content-between">
      {tabs &&
        tabs.length > 0 &&
        tabs.map((item, key) => {
          const isReceived = item.title === "received_requests";
          const isSent = item.title === "sent_requests";
          return (
            <li
              className={`text-uppercase text-center py-3 ${
                item.title == activeTab.title ? "active" : ""
              }`}
              onClick={() => handleTabChange(key)}
              key={key}
            >
              <SpanStyled size="14px">{t(item.title)}</SpanStyled>
              {receivedRequestsCount &&
              receivedRequestsCount > 0 &&
              isReceived ? (
                <span className="notification-badge position-absolute top-0">
                  {receivedRequestsCount}
                </span>
              ) : null}
              {sentRequestsCount && sentRequestsCount > 0 && isSent ? (
                <span className="notification-badge position-absolute top-0">
                  {sentRequestsCount}
                </span>
              ) : null}
            </li>
          );
        })}
    </TabStyled>
  );
};

export const ExcelInputWrapper = styled.label`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8.5px 16px;
  font-size: 16px;
  background-color: var(--themeColor2);
  color: white;
  border-radius: 10px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  text-align: center;

  input {
    display: none;
  }
`;

export const ButtonStyled = (props) => {
  const unwantedProps = [
    "icon",
    "label",
    "className",
    "clName",
    "onClick",
    "isLoading",
  ];
  const buttonProps = props.type ? { type: props.type } : { type: "button" };
  return (
    <ButtonWrapper
      {...sliceProps(props, unwantedProps)}
      className={`${props.clName ? props.clName : ""}`}
      disabled={props.disabled}
    >
      <button
        className={`d-flex align-items-center justify-content-center ${
          props.className || ""
        } ${!props.icon ? "Btn-icon" : ""} `}
        {...buttonProps}
        onClick={props.onClick}
        autoComplete="false"
        disabled={props.disabled || props.isLoading}
        type={props.type}
      >
        {props.isLoading ? (
          <Spinner className="custom-spinner" />
        ) : (
          <>
            {props.icon && <props.icon width="14px" />}
            <SpanStyled weight={props.weight && props.weight} color={props.color && props.color} size={props.size ? props.size : "16px"}>
              {props.label ? props.label : ""}
            </SpanStyled>
          </>
        )}
      </button>
    </ButtonWrapper>
  );
};
export const FormButtonStyled = (props) => {
  const unwantedProps = [
    "icon",
    "label",
    "className",
    "clName",
    "onClick",
    "isLoading",
  ];
  const buttonProps = props.type ? { type: props.type } : { type: "button" };
  return (
    <FormButtonWrapper
      {...sliceProps(props, unwantedProps)}
      className={`${props.clName ? props.clName : ""}`}
      disabled={props.disabled}
    >
      <button
        className={`d-flex align-items-center justify-content-center ${
          props.className || ""
        } ${!props.icon ? "Btn-icon" : ""} `}
        {...buttonProps}
        onClick={props.onClick}
        autoComplete="false"
        disabled={props.disabled || props.isLoading}
      >
        {props.isLoading ? (
          <Spinner className="custom-spinner" />
        ) : (
          <>
            <SpanStyled size={props.size ? props.size : "18px"}>
              {props.label ? props.label : ""}
            </SpanStyled>
            {props.icon && <props.icon width="22px" />}
          </>
        )}
      </button>
    </FormButtonWrapper>
  );
};
const colorMap = {
  A: "#3498db",
  B: "#e74c3c",
  C: "#2ecc71",
  D: "#f39c12",
  E: "#9b59b6",
  F: "#34495e",
  G: "#1abc9c",
  H: "#e67e22",
  I: "#27ae60",
  J: "#3498db",
  K: "#e74c3c",
  L: "#2ecc71",
  M: "#f39c12",
  N: "#9b59b6",
  O: "#34495e",
  P: "#1abc9c",
  Q: "#e67e22",
  R: "#27ae60",
  S: "#3498db",
  T: "#e74c3c",
  U: "#2ecc71",
  V: "#f39c12",
  W: "#9b59b6",
  X: "#34495e",
  Y: "#1abc9c",
  Z: "#e67e22",
};
//#endregion color
export const DefaultProfileAvatar = ({ customClass, userDetail }) => {
  let combinedInitials = "";
  let backgroundStyle = {};

  const getInitials = (name, wordsCount = 2) => {
    return name
      .split(" ")
      .slice(0, wordsCount)
      .map((word) => word[0])
      .join("")
      .toUpperCase();
  };

  const token = localStorage.getItem("userInfo");
  let user = JSON.parse(token);

  if (userDetail) user = userDetail;
  else user = user.data.user ? user.data.user : user?.data;

  if (user) {
    const firstNameInitial = getInitials(user.first_name || user.user_name);
    const lastNameInitial = user.last_name ? getInitials(user.last_name) : "";
    combinedInitials = `${firstNameInitial}${lastNameInitial}`;
    if (userDetail) {
      backgroundStyle = {
        backgroundColor: colorMap[firstNameInitial],
      };
    }
  }

  return (
    <ProfileAvatarContainer
      className={`profile-avatar-container ${customClass}`}
    >
      <div className="profile-avatar-placeholder" style={backgroundStyle}>
        {combinedInitials}
      </div>
    </ProfileAvatarContainer>
  );
};

export const ProfileAvatarContainer = styled.div`
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  transform: unset !important;

  .profile-avatar-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    line-height: 14px;
    font-family: var(--medium);
    color: #ffffff;
    /* background-color: #078c61; */
    body.rtl & {
      font-family: var(--arRegular);
    }
  }
`;

export const NotAuthorized = (props) => {
  const { t } = useTranslation();
  return (
    <NotAuthorizedWrapper
      className={`${props.className ? props.className : ""}`}
    >
      <HeadingStyled color="var(--text)">
        {t("not_authorized_for_page")}
      </HeadingStyled>
    </NotAuthorizedWrapper>
  );
};
export const SubscriptionExpired = (props) => {
  const { t } = useTranslation();
  return (
    <NotAuthorizedWrapper
      className={`${props.className ? props.className : ""}`}
    >
      <HeadingStyled color="var(--text)">
        {t("subscription_expired_message")}
      </HeadingStyled>
    </NotAuthorizedWrapper>
  );
};
export const NotAuthorizedForResource = (props) => {
  const { t } = useTranslation();
  return (
    <NotAuthorizedWrapper
      className={`${props.className ? props.className : ""}`}
    >
      <HeadingStyled color="var(--text)">
        {t("not_authorized_for_resource")}
      </HeadingStyled>
    </NotAuthorizedWrapper>
  );
};
export const NotAuthorizedWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 18px;
  line-height: 1;
  margin-top: 5rem;
`;
export const NoDataFoundContainer = (props) => {
  const { t } = useTranslation();
  return (
    <NoDataFound className={`${props.className ? props.className : ""}`}>
      <TextStyled>{t("no_data_found")}</TextStyled>
    </NoDataFound>
  );
};
export const NoDataFound = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  text-align: center;
  font-size: 18px;
  line-height: 1;
  font-family: var(--medium);
  body.rtl & {
    font-family: var(--arRegular);
  }
`;

export const DataContainerHeader = (props) => {
  const { t } = useTranslation();
  const unwantedProps = [
    "icon",
    "label",
    "className",
    "clName",
    "onClick",
    "isLoading",
    "btnLabel",
    "backBtnLabel",
    "onClickBack",
    "noBreadcrumbs",
  ];

  return (
    <DataHeader
      {...sliceProps(props, unwantedProps)}
      className={`${props.clName ? props.clName : ""}`}
    >
      <Box className="d-flex flex-wrap gap-3">
        {props.backBtnLabel && (
          <>
            <BackButton
              label={t(props.backBtnLabel)}
              // backBtnLabel= {props.backBtnLabel}
              onClick={props.onClickBack}
              // onClick={() => navigate("/users")}
              clName="secHeadSpn"
            />
            {props.noBreadcrumbs && <Breadcrumbs />}
          </>
        )}
        {!props.backBtnLabel && (
          <SpanStyled color="var(--text)" size="20px" weight="bold">
            {props.label && props.label}
          </SpanStyled>
        )}
      </Box>
      {props.btnLabel && (
        <ButtonStyled
          label={t(props.btnLabel)}
          icon={props.icon}
          onClick={props.onClick}
          type="button"
        />
      )}
    </DataHeader>
  );
};

export const DataHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 25px 12px 25px;
  border-bottom: 1px solid var(--borderLight);
  width: 100%;
  span.secHeadSpn {
    color: var(--text);
    font-size: 20px;
    font-family: var(--regularBold);
  }
  body.rtl & {
    span {
      font-family: var(--arBoldSans);
    }
  }
  @media (max-width: 576px) {
    flex-wrap: wrap;
  }
`;

export const CheckList = ({ listData, listBlue }) => {
  const { t } = useTranslation();
  return (
    <CheckListing>
      <ul>
        {listData.map((item) => (
          <li key={item.id}>
            <Box>{listBlue ? <BlueSuccessCheck /> : <GreenSuccessCheck />}</Box>
            <SpanStyled size="16px" color="var(--text)">
              {t(item.listTxt)}
            </SpanStyled>
          </li>
        ))}
      </ul>
    </CheckListing>
  );
};

export const CheckListing = styled.div`
  display: flex;
  width: 100%;
  padding-top: 40px;
  padding-bottom: 10px;
  ul {
    li {
      display: flex;
      width: 100%;
      gap: 15px;
      align-items: flex-start;
      margin-bottom: 20px;
      svg {
        width: 20px;
        height: auto;
        margin-top: 3px;
      }
      body.rtl & {
        span {
          font-family: var(--arRegular);
        }
      }
    }
  }
`;

export const Separator = (props) => {
  <SeparatorBorder></SeparatorBorder>;
};
export const SeparatorBorder = styled.div`
  display: block;
  width: 100%;
  height: 1px;
  background-color: var(--borderLight);
`;

const DropdownStyled = styled.select`
  border: 1px solid ${({ border }) => (border ? border : "var(--border)")};
  border-radius: 8px;
  height: 48px;
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
  outline: none;
  background: ${({ background }) =>
    background ? background : "var(--bgSecondary)"};
  color: var(--text);
  cursor: pointer;
  &.countryDropdown {
    font-family: "Noto Color Emoji", "TheSans";
  }
  .label {
    color: var(--text2);
  }

  &::placeholder {
    color: var(--text2);
  }
  option[disabled] {
    color: var(--text2);
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  width: fit-content;
  button,
  button::after {
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    -o-transition: all 0.5s;
    transition: all 0.5s;
  }
  button {
    background: ${(props) => (props.bg ? props.bg : "var(--themeColor)")};
    border: 1px solid
      ${(props) => (props.border ? props.border : "transparent")};
    display: flex;
    gap: 8px;
    padding: ${(props) => (props.padding ? props.padding : "7px 20px")};
    position: relative;
    border-radius: 10px;
    /* box-shadow: ${({ shadow }) =>
      shadow ? shadow : "0px 4px 8px 0px #064a9340"}; */
    span {
      text-wrap: nowrap;
      /* font-family: var(--regular); */
      color: ${(props) => (props.color ? props.color : "var(--white)")};
    }
    .custom-spinner {
      color: ${(props) => (props.color ? props.color : "var(--white)")};
    }
    & svg {
      height: 22px;
      [fill] {
        /* fill: var(--themeColor); */
      }
    }
    /* &:hover {
      background: var(--hoverBg);
    } */
    ${(props) =>
      props.disabled &&
      `
        opacity: 0.5;
      `}
  }
`;
export const FormButtonWrapper = styled.div`
  display: flex;
  width: fit-content;
  button,
  button::after {
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    -o-transition: all 0.5s;
    transition: all 0.5s;
  }
  button {
    background: ${(props) => (props.bg ? props.bg : "var(--themeColor)")};
    border: 1px solid
      ${(props) => (props.border ? `var(${props.border})` : "transparent")};
    display: flex;
    gap: 12px;
    height: 50px;
    padding: 0px 20px;
    position: relative;
    border-radius: 10px;
    box-shadow: ${({ shadow }) =>
      shadow ? shadow : "0px 4px 8px 0px #064a9340"};
    span {
      text-wrap: nowrap;
      /* font-family: var(--regular); */
      color: ${(props) => (props.color ? props.color : "var(--white)")};
    }
    .custom-spinner {
      color: ${(props) => (props.color ? props.color : "var(--white)")};
    }
    & svg {
      height: 22px;
      [fill] {
        fill: var(--darkColor);
      }
    }
    /* &:hover {
      background: var(--hoverBg);
    } */
    ${(props) =>
      props.disabled &&
      `
        opacity: 0.5;
      `}
  }
`;

export const BackButtonWrapper = styled.div`
  span {
    text-wrap: nowrap;
  }
  button {
    background: none !important;
    &.icon-box {
      width: 28px;
      height: 28px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border-radius: 6px;
      body.rtl & svg {
        transform: scale(-1);
      }
    }
  }
`;

export const FormEleWrapper = styled.div`
  padding: 9px 0px 9px 0px;
  border-bottom: 1px solid var(--borderLight);
  width: 100%;
  .formEleContainer {
    display: flex;
    padding: 7px 0px 7px 0px;
    margin: 7px 0 7px 0;
    align-items: center;
    gap: 5px;
    & > label {
      min-width: 160px;
    }
  }
  .formEleContainer.inp-white {
    input {
      background-color: var(--white);
    }
  }
  .form-floating {
    width: 100%;
  }
  input[type="text"] {
    width: 100%;
  }
  @media (max-width: 767px) {
    .formEleContainer {
      flex-wrap: wrap;
      gap: 4px;
      label {
        width: 100%;
      }
    }
  }
`;
export const FormElementWrapper = styled.div`
  padding: 9px 25px 9px 25px;
  border-bottom: 1px solid var(--borderLight);
  width: 100%;
  .formEleContainer {
    display: flex;
    padding: 7px 0px 7px 0px;
    margin: 7px 0 7px 0;
    align-items: center;
    gap: 5px;
    & > label {
      min-width: 160px;
    }
  }
  &.combined {
    border-bottom: none;
    padding: 8px 25px 8px 25px;
    &:last-child {
      border-bottom: 1px solid var(--borderLight);
    }
    .formEleContainer {
      display: flex;
      padding: 0;
      margin: 0;
    }
  }
  .formEleContainer.inp-white {
    input {
      background-color: var(--white);
    }
  }
  .form-floating {
    width: 100%;
  }
  input[type="text"] {
    width: 100%;
  }
`;

export const TabStyled = styled.ul`
  overflow-x: auto;
  background-color: var(--white);
  border-bottom: 1px solid var(--border);
  .notification-badge {
    text-align: center;
    font-size: 10px !important;
    color: #fff !important;
    width: 17px;
    height: 17px;
    border-radius: 9999px;
    background-color: #d11b07;
    line-height: 20px;
    display: inline-block;
  }

  li {
    white-space: nowrap;
    width: 50%;
    cursor: pointer;
    position: relative;
    &:not(.active) {
      color: var(--text);
      font-weight: 500;
    }
    &.active {
      color: var(--themeColor);
      font-weight: 700;
      &::before {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 3px;
        border-radius: 20px;
        background-color: var(--themeColor);
      }
    }
  }
  @media (max-width: 768px) {
    li {
      min-width: fit-content;
      padding-left: 25px;
      padding-right: 25px;
    }
  }
`;
const StatusContainer = styled.div`
  border-radius: 4px;
  padding: 8px;
  width: fit-content;

  .status-color-box {
    position: relative;
    width: 20px;
    &::before {
      content: "";
      position: absolute;
      top: -6px;
      left: 3px;
      width: 10px;
      height: 10px;
      background-color: ${({ status }) =>
        status == 1 ? "var(--themeColor2)" : "var(--redColor)"};
      border-radius: 3px;
      display: inline-block;
      body.rtl & {
        left: unset;
        right: 3px;
      }
    }
    &::after {
      content: "";
      position: absolute;
      top: -9px;
      left: 0;
      width: 16px;
      height: 16px;
      border: 1px solid
        ${({ status }) =>
          status == 1 ? "var(--themeColor2)" : "var(--redColor)"};
      border-radius: 3px;
      display: inline-block;

      body.rtl & {
        left: unset;
        right: 0;
      }
    }
  }

  span {
    color: ${({ status }) =>
      status == 1 ? "var(--themeColor2)" : "var(--redColor)"};
    font-size: 16px;
    font-weight: 500;
  }
`;

export const CountdownTimer = ({ endTime }) => {
  const { t } = useTranslation();
  const [remaining, setRemaining] = useState(getRemainingParts(endTime));

  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining(getRemainingParts(endTime));
    }, 1000);

    return () => clearInterval(interval);
  }, [endTime]);

  if (!remaining) {
    return <div style={{ textAlign: "center" }}>{t("timer_not_started")}</div>;
  }

  return (
    <div style={{ textAlign: "center" }}>
      <TimerWrapper>
        <TimeBlock>
          <div className="value">{remaining.days}</div>
          <div className="label">{t("d")}</div>
        </TimeBlock>
        <TimeBlock>
          <div className="value">{remaining.hours}</div>
          <div className="label">{t("h")}</div>
        </TimeBlock>
        <TimeBlock>
          <div className="value">{remaining.minutes}</div>
          <div className="label">{t("m")}</div>
        </TimeBlock>
        <TimeBlock>
          <div className="value">{remaining.seconds}</div>
          <div className="label">{t("s")}</div>
        </TimeBlock>
      </TimerWrapper>
    </div>
  );
};

const TimerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  font-family: "Segoe UI", sans-serif;
  margin-top: 12px;
`;

const TimeBlock = styled.div`
  text-align: center;

  .value {
    font-size: 14px;
    font-weight: 500;
    color: var(--text);
  }

  .label {
    font-size: 14px;
    color: lightgray;
    margin-top: 4px;
  }
`;

export const DurationToggleContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 1.5rem 0;
`;

export const DurationToggle = styled.div`
  display: flex;
  border-radius: 50px;
  background-color: var(--themeColor);
  padding: 5px;
  width: fit-content;
`;

export const DurationOption = styled.button`
  background-color: ${({ active }) => (active ? "white" : "var(--themeColor)")};
  color: ${({ active }) => (active ? "var(--themeColor)" : "white")};
  font-weight: 600;
  padding: 10px 25px;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  transition: 0.3s ease;
  font-size: 16px;

  &:hover {
    opacity: 0.85;
  }
`;
